<template>
  <div class="data-extraction-panel-footer">
    <v-row
      no-gutters
      justify="center"
      align="center"
      class="grey lighten-3 pa-4"
    >
      <action-button
        color="primary"
        :disabled="disabled"
        @click="$emit('submit')"
      >
        <template v-if="consensusReview">
          <v-icon left class="material-icons-outlined">
            assignment_turned_in
          </v-icon>
          Complete Review
        </template>
        <template v-else>
          <v-icon left class="material-icons-outlined">
            forward
          </v-icon>
          Submit For Consensus
        </template>
      </action-button>
    </v-row>
  </div>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
export default {
  name: 'DataExtractionPanelFooter',
  components: { ActionButton },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    consensusReview: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';
.data-extraction-panel-footer {
  border-top: 1px solid map-get($grey, 'lighten-2') !important;
}
</style>
